module.exports = __webpack_public_path__ + "static/profile-3e5bb14ab95d0d7b7b381adb2d97f3ca.png";